import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Image,
  Popconfirm,
  message,
  ConfigProvider,
  Tooltip,
} from "antd";
import { DeleteOutlined, ShopOutlined } from "@ant-design/icons";
import "./productList.css";
import { routes } from "../../api/routes";
import { callApi } from "../../api/apiCaller";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAllProducts = () => {
    let getRes = (res) => {
      // Accessing the data path as per your sample
      setProducts(res?.data?.products || []);
    };

    callApi(
      "GET",
      routes.getAllProducts, // Make sure this route is defined in your routes file
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        message.error("Failed to fetch products");
      }
    );
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  const handleDelete = (id) => {
    let getRes = (res) => {
      console.log("res of delete product", res);
      message.success("Product removed from inventory");
      getAllProducts();
    };

    callApi(
      "DELETE",
      `${routes.deleteProduct}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
    // Re-fetch logic here
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "productName",
      key: "productName",
      render: (text, record) => (
        <div className="user-info-cell">
          <div className="product-img-container">
            <Image
              src={record.productCoverImage}
              fallback="https://placehold.co/50x50?text=No+Image"
              className="product-img"
            />
          </div>
          <div>
            <div className="user-name">{text}</div>
            <small style={{ color: "#8c8c8c" }}>
              ID: {record._id.slice(-6)}
            </small>
          </div>
        </div>
      ),
    },
    {
      title: "Vendor",
      dataIndex: ["vendorId", "name"], // Accessing nested object
      key: "vendor",
      render: (vendorName) => (
        <span>
          <ShopOutlined style={{ marginRight: 8, color: "#FFA450" }} />
          {vendorName || "Unknown Vendor"}
        </span>
      ),
    },
    {
      title: "Price",
      dataIndex: "productPrice",
      key: "price",
      render: (price) => <span className="price-text">₦{price}</span>,
    },
    {
      title: "Qty",
      dataIndex: "productQuantity",
      key: "quantity",
      responsive: ["md"],
    },
    {
      title: "Variants",
      dataIndex: "variants",
      key: "variants",
      render: (variants) => (
        <Tooltip
          title={variants?.map((v) => `${v.size} (${v.color})`).join(", ")}
        >
          <Tag className="variant-tag">{variants?.length || 0} Variants</Tag>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) => (
        <Tag color={isActive ? "orange" : "default"}>
          {isActive ? "Live" : "Hidden"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Delete Product"
          description="Are you sure you want to delete this product?"
          onConfirm={() => handleDelete(record._id)}
          okText="Delete"
          cancelText="Cancel"
          okButtonProps={{ danger: true, type: "primary" }}
        >
          <DeleteOutlined className="delete-action" />
        </Popconfirm>
      ),
    },
  ];

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#FFA450",
          fontFamily: "Roboto, sans-serif",
        },
      }}
    >
      <div className="user-table-container">
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ margin: 0 }}>Products Management</h2>
        </div>
        <Table
          columns={columns}
          dataSource={products}
          loading={isLoading}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 8 }}
        />
      </div>
    </ConfigProvider>
  );
};

export default ProductList;
